export type FacebookMethod = "get" | "post" | "delete";
export type FacebookEvent =
    | "auth.authResponseChanged"
    | "auth.statusChange"
    | "auth.login"
    | "auth.logout"
    | "comment.create"
    | "comment.remove"
    | "edge.create"
    | "edge.remove"
    | "message.send"
    | "xfbml.render";

export interface FacebookSDKInitOptions {
    appId: string;
    status?: boolean;
    autoLogAppEvents: boolean;
    xfbml: boolean;
    version: string;
    cookies?: boolean;
}

export interface FacebookSDKConfig {
    appId: string;
    xfbml: boolean;
    version: string;
    cookies?: boolean;
    configId: string;
}

export interface FacebookUIParams extends Record<string, any> {
    method: FacebookMethod;
}

export interface FacebookLoginOptions {
    config_id: number | string;
    response_type: "code";
    override_default_response_type: true;
    extras: {
        setup: Record<string, any>;
        sessionInfoVersion: `${number}`;
        featureType: string;
    };
}

export interface FacebookSDK {
    init(options: FacebookSDKInitOptions): void;

    api(
        path: string,
        method: FacebookMethod,
        params: Record<string, any>,
        callback: (response: any) => void,
    ): void;

    ui(params: FacebookUIParams, callback: (response: any) => void): void;

    getLoginStatus(callback?: (response: any) => void): void;

    login(
        callback?: (response: any) => void,
        options?: Partial<FacebookLoginOptions>,
    ): void;

    logout(callback?: (response: any) => void): void;

    getAuthResponse(): Record<string, any>;

    Event: {
        subscribe(
            event: FacebookEvent,
            callback?: (response: any) => void,
        ): void;
        unsubscribe(
            event: FacebookEvent,
            callback?: (response: any) => void,
        ): void;
    };
    XFBML: {
        parse(...args: any): void;
    };
}

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig().public
        .facebook as unknown as FacebookSDKConfig;

    // SDK initialization
    // @ts-expect-error weré not using ts for this
    window.fbAsyncInit = () => {
        // @ts-expect-error weré not using ts for this
        FB.init({
            appId: config.appId,
            autoLogAppEvents: true,
            xfbml: true,
            status: true,
            cookies: true,
            version: config.version,
        });
    };

    (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        // @ts-expect-error weré not using ts for this
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        // @ts-expect-error weré not using ts for this
        fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    // Session logging message event listener
    window.addEventListener("message", (event) => {
        if (
            event.origin !== "https://www.facebook.com" &&
            event.origin !== "https://web.facebook.com"
        )
            return;
        try {
            const data = JSON.parse(event.data);
            if (data.type === "WA_EMBEDDED_SIGNUP") {
                console.log("message event: ", data); // remove after testing
                // your code goes here
            }
        } catch {
            console.log("message event: ", event.data); // remove after testing
            // your code goes here
        }
    });

    return {
        provide: {
            facebookConfig: config,
        },
    };
});
